import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the promotional codes table view.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Editar'), // Tooltip for edit action
                                    template: function (obj) {
                                        // Template function for rendering edit icon
                                        if (devConfig.getPermAction('betShopReportsPromotionalCodesEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon if permission granted
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Code', // Column ID
                                    header: _('Código'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de Creación'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'LinkId', // Column ID
                                    header: _('LinkId'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for the combo box
                                        { id: 'A', value: _('Activo') }, // Active option
                                        { id: 'I', value: _('Inactivo') }, // Inactive option
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit action
                                    $$('EditCode').show(); // Show edit popup
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the DataTable
        const cur_user = this.getParam('user', true); // Current user parameter
        var url =
            devConfig.geturlApi() + // Base API URL
            'es/PromotionalCodes/GetCodes?FromId=' + // Endpoint for fetching promotional codes
            cur_user +
            '&';
        var filter = ''; // Filter string for API requests

        // Event listener for promotional codes filtering
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo2=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item clicks
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });

        // Popup configuration for editing codes
        var popup = webix.ui({
            view: 'window', // Window component
            id: 'EditCode', // ID for the edit popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Editar Código') }, // Label for the header
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form component
                id: 'editForm', // ID for the edit form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only ID field
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code input field
                    {
                        view: 'text',
                        label: _('Fecha de Creación'), // Creation date field
                        labelWidth: 140,
                        name: 'CreatedLocalDate',
                        readonly: true, // Read-only field
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // LinkId input field
                    {
                        view: 'combo', // Combo box for activation status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Inactivated option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to update code
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/UpdateCode',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Código Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Create formatted current local date
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Popup configuration for adding codes
        var popupAdd = webix.ui({
            view: 'window', // Window component
            id: 'AddCode', // ID for the add popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Añadir Código') }, // Label for the header
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form component
                id: 'addform', // ID for the add form
                elements: [
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code input field
                    {
                        view: 'text',
                        label: _('Fecha de Creación'), // Creation date field
                        labelWidth: 140,
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set default value to current date
                        readonly: true, // Read-only field
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // LinkId input field
                    {
                        view: 'combo', // Combo box for activation status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Inactivated option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to add code
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/AddCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                createdLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Código Agregado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for adding codes
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show add popup
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to DataTable
    }
}

// FILE DOCUMENTED
